import dynamic from 'next/dynamic';

const Play = dynamic(() => import('./play'), { ssr: false });

export default function RealStore() {
  return (
    <div>
      <h2 className="text-center mt-20">
        <div className="text-[30px] font-bold mb-6">Real Stories:</div>
        <div className="bg-gradient-to-r from-purple-500 to-pink-500 bg-clip-text w-fit mx-auto text-transparent text-[30px] font-bold leading-8">
          Using Dolphin Radar to Check Instagram Followers
        </div>
      </h2>
      <Play />
    </div>
  );
}
